import React from "react";
import Header from "./Header";
import { useSidebar } from "../contexts/SideBarContext";
import "../assets/css/layout.css";

/**
 * Layout component que envuelve el contenido principal
 * y ajusta el margen cuando el sidebar esta abierto
 */
const Layout = ({ children }) => {
    const { isSidebarOpen } = useSidebar();

    return (
        <div className="app-layout">
            <Header />
            <main className={`main-content ${isSidebarOpen ? "sidebar-open" : ""}`}>
                {children}
            </main>
        </div>
    );
};

export default Layout;